/* istanbul ignore file */

// declarative file
export const AppConstants = {
  BASENAME: process.env.PUBLIC_URL || 'support',
  PUBLIC_URL: process.env.PUBLIC_URL,
};
